import Title from './../../types/Title';

export const getTitleJacketUri = (
	product: Title,
	height = 600,
): string | null => {
	const jacketCover = product?.images?.filter(
		im => im.type === 'jacketCover',
	);
	const uri =
		jacketCover?.length > 0
			? jacketCover[0].uri + `?height=${height}`
			: null;
	return uri;
};
